import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3db41204&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db41204",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3db41204')) {
      api.createRecord('3db41204', component.options)
    } else {
      api.reload('3db41204', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3db41204&scoped=true", function () {
      api.rerender('3db41204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/baseConfig/index.vue"
export default component.exports